import React from 'react';
import { Container, Typography, Grid, Box, Card, CardContent } from '@mui/material';
import ComputerIcon from '@mui/icons-material/Computer';
import BuildIcon from '@mui/icons-material/Build';
import MemoryIcon from '@mui/icons-material/Memory';
import SpeedIcon from '@mui/icons-material/Speed';

const solutions = [
  {
    icon: ComputerIcon,
    title: 'Custom PC Building',
    description: 'Get a custom-built PC tailored to your specific needs, whether for gaming, content creation, or professional work.'
  },
  {
    icon: BuildIcon,
    title: 'Hardware Optimization',
    description: 'Expert hardware configuration and optimization to ensure maximum performance and reliability.'
  },
  {
    icon: MemoryIcon,
    title: 'Component Selection',
    description: 'Professional guidance in selecting the best components that match your requirements and budget.'
  },
  {
    icon: SpeedIcon,
    title: 'Performance Tuning',
    description: 'Advanced system tuning and optimization for peak performance and stability.'
  }
];

function ExpertSolutions() {
  return (
    <Box sx={{ bgcolor: 'background.default', py: 8 }}>
      <Container>
        <Typography 
          variant="h2" 
          align="center" 
          gutterBottom
          className="gradient-text"
          sx={{ mb: 6 }}
        >
          Expert Solutions
        </Typography>
        <Typography 
          variant="h5" 
          align="center" 
          color="text.secondary" 
          sx={{ mb: 8, maxWidth: 800, mx: 'auto' }}
        >
          Experience professional-grade technical solutions tailored to your needs
        </Typography>

        <Grid container spacing={4}>
          {solutions.map((solution, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card 
                className="glass-effect"
                sx={{ 
                  height: '100%',
                  background: 'linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(37, 99, 235, 0.2) 100%)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '15px',
                  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)'
                  }
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    {React.createElement(solution.icon, { 
                      sx: { 
                        fontSize: 40, 
                        color: 'primary.main',
                        mr: 2 
                      } 
                    })}
                    <Typography variant="h5" component="h3">
                      {solution.title}
                    </Typography>
                  </Box>
                  <Typography variant="body1" color="text.secondary">
                    {solution.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 8, textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom className="gradient-text">
            Why Choose Our Expert Solutions?
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto', mb: 4 }}>
            Our team of certified professionals brings years of experience in delivering high-quality technical solutions. 
            We stay up-to-date with the latest technologies to provide you with the best possible service.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default ExpertSolutions;
